export default __webpack_public_path__ + "static/media/ryzen3600.ac69e40b.jpg";